// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.wFdMJK {
  display: flex;
  flex-direction: column;
  gap: var(--spacing-1-5);
  height: 100%;
  overflow: hidden;
  flex: 1;
  min-width: 0;
}

.iM1I3l {
  position: relative;
  flex: 1;
  min-height: 0;
  padding: var(--spacing-3);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
}

.M7uulK {
  margin-bottom: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 120px;
  height: 120px;
  border-radius: 50%;
}

.AbDg0b {
  background-color: #fef2f2;
}

.vQFkaW {
  width: 48px;
  height: 48px;
  color: #dc2626;
}

.NgBmXH {
  font-size: 16px;
  font-weight: 700;
  color: #0f172a;
  margin-bottom: 1rem;
  line-height: 1.3;
  letter-spacing: -0.02em;
}

.NPB8Wx {
  font-size: 14px;
  color: #475569;
  margin-bottom: 0;
  line-height: 1.6;
  max-width: 380px;
}

@media (max-width: 768px) {
  .wFdMJK {
    gap: 16px;
  }
  .iM1I3l {
    padding: 2.5rem 2rem;
  }
  .M7uulK {
    width: 100px;
    height: 100px;
  }
  .vQFkaW {
    width: 64px;
    height: 64px;
  }
  .NgBmXH {
    font-size: 1.5rem;
  }
  .NPB8Wx {
    font-size: 0.95rem;
    max-width: 100%;
  }
}
`, "",{"version":3,"sources":["webpack://./../../packages/beneficios/src/pages/HiringPage/components/HiringError/HiringError.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,YAAY;EACZ,gBAAgB;EAChB,OAAO;EACP,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,OAAO;EACP,aAAa;EACb,yBAAyB;EACzB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE;IACE,SAAS;EACX;EACA;IACE,oBAAoB;EACtB;EACA;IACE,YAAY;IACZ,aAAa;EACf;EACA;IACE,WAAW;IACX,YAAY;EACd;EACA;IACE,iBAAiB;EACnB;EACA;IACE,kBAAkB;IAClB,eAAe;EACjB;AACF","sourcesContent":[".stepContent {\n  display: flex;\n  flex-direction: column;\n  gap: var(--spacing-1-5);\n  height: 100%;\n  overflow: hidden;\n  flex: 1;\n  min-width: 0;\n}\n\n.activationFeedbackContent {\n  position: relative;\n  flex: 1;\n  min-height: 0;\n  padding: var(--spacing-3);\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  text-align: center;\n}\n\n.iconContainer {\n  margin-bottom: 20px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 120px;\n  height: 120px;\n  border-radius: 50%;\n}\n\n.errorIconContainer {\n  background-color: #fef2f2;\n}\n\n.errorIcon {\n  width: 48px;\n  height: 48px;\n  color: #dc2626;\n}\n\n.title {\n  font-size: 16px;\n  font-weight: 700;\n  color: #0f172a;\n  margin-bottom: 1rem;\n  line-height: 1.3;\n  letter-spacing: -0.02em;\n}\n\n.description {\n  font-size: 14px;\n  color: #475569;\n  margin-bottom: 0;\n  line-height: 1.6;\n  max-width: 380px;\n}\n\n@media (max-width: 768px) {\n  .stepContent {\n    gap: 16px;\n  }\n  .activationFeedbackContent {\n    padding: 2.5rem 2rem;\n  }\n  .iconContainer {\n    width: 100px;\n    height: 100px;\n  }\n  .errorIcon {\n    width: 64px;\n    height: 64px;\n  }\n  .title {\n    font-size: 1.5rem;\n  }\n  .description {\n    font-size: 0.95rem;\n    max-width: 100%;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"stepContent": `wFdMJK`,
	"activationFeedbackContent": `iM1I3l`,
	"iconContainer": `M7uulK`,
	"errorIconContainer": `AbDg0b`,
	"errorIcon": `vQFkaW`,
	"title": `NgBmXH`,
	"description": `NPB8Wx`
};
module.exports = ___CSS_LOADER_EXPORT___;
